// Shared default state for the organisation reducer.
//
// SCIL-17744: People (was `filters`) and Activity (was `workItemFilters`)
// now share ONE per-orgId filter slice: `filters`. Clinical Trials keep
// their own `clinicalTrialFilters` slice (the CT tab reuses the `leadSponsor`
// key with different semantics, so it must not be merged).
//
// Per-tab paging, sort, results caching and changed-flags stay separate;
// only the filter INPUTS are shared. `changedFilters[orgId]` (People) and
// `workItemChangedFilters[orgId]` (Activity) mean "shared filters changed
// since this tab last searched": filter mutations set both, each PERFORM_*
// clears its own. Tab activation re-runs a tab whose flag is still set.

export const defaultState = {
  organisationResearchers: {},
  organisationExhibitors: {},
  organisationClinicalTrials: {},
  totals: {},
  workItemTotals: {},
  tradeshowTotals: {},
  clinicalTrialTotals: {},
  clinicalTrialPageNumbers: {},
  clinicalTrialPageSize: {},
  clinicalTrialSort: {},
  clinicalTrialFilters: {},
  pageNumbers: {},
  pageSizes: {},
  loading: {},
  researcherSearchError: {},
  workItemSearchError: {},
  clinicalTrialSearchError: {},
  filters: {},
  changedFilters: {},
  sort: {},
  purchasingLastSuccessfulSearch: {},
  purchasingSearchRequest: {},
  purchasingFilters: {
    term: '',
  },
  purchasingPageSize: 100,
  purchasingPageNumber: 0,
  purchasingLoading: false,
  blockedForPurchasingExport: false,
  showNotice: true,
  showClinicalTrialNotice: true,
  workItemPageNumbers: {},
  workItemHighlight: {},
  workItemPageSize: {},
  workItemSort: {},
  workItemSearchRequest: {},
  workItemLoading: {},
  workItems: {},
  workItemChangedFilters: {},
  view: 'workItems',
  loadingExhibitorData: {},
  loadingClinicalTrialData: {},
  blockedForWorkItemExport: {},
  blockedForResearchersExport: {},
  blockedForClinicalTrialExport: {},
  organisationToCheckInIndex: null,
  organisationsCache: {},
};
